/**
* IMPORT
*/
import Vue from "vue";
import App from "./App.vue";
import Popup from "./Popup.vue";
import router from "./router";
import store from "./store";
import "jquery";
import "./plugins/http";

import "./assets/css/basic.css";
import "./assets/css/ware_common.css";

import "slick-carousel/slick/slick.min.js"
import "slick-carousel/slick/slick.css";

/**
* JS
*/
require("@/assets/js/common.js");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

new Vue({
  router,
  store,
  render: h => h(Popup)
}).$mount("#popup");